<template>
  <dialog-drag
    :id="id"
    :ref="'dialog-' + id"
    @close="removeDialog"
    @drag-end="dialogDragEnd"
    @drag-start="selectDialog"
    @move="dialogDragEnd"
    class="dialog-drag-display"
    style="width: 1100px !important; top: 0 !important"
  >
    <template v-slot:title>
      <v-card-title class="headline white--text" primary-title>
        {{ $t('lbl.codetable.codeDataPool.pageHeader') }}
      </v-card-title>
    </template>
    <template v-slot:button-close>
      <v-btn small text icon @click="removeDialog">
        <icon-svg iconName="close" />
      </v-btn>
    </template>
    <v-row class="ma-0" style="height: 548px">
      <v-col cols="" class="pa-0">
        <v-card-text class="pa-0 data-section code-data-pool">
          <v-row class="ma-0">
            <v-col class="pa-0">
              <v-row class="mx-0 mb-2">
                <v-col lg="3" class="comm-header-col date-query-section pb-0 pl-0 pt-0">
                  <div class="code-table-section">
                    <div
                      :class="[
                        'code-table-label',
                        $vuetify.theme.dark ? 'white--text' : 'black--text',
                      ]"
                      v-html="$t('lbl.codetable.totalCount', [totalCount])"
                    ></div>
                  </div>
                </v-col>
                <v-col lg="3" class="comm-header-col date-query-section pb-0 pr-0 pt-0 mt-0">
                  <div class="pl-0 pt-0 pb-0">
                    <v-text-field
                      v-model="codeDataPoolItems.data[0].GRP_CD"
                      class="data-table-filter-text-field search-button-data-analysis-table"
                      height="30"
                      :placeholder="$t('lbl.common.conditionSearch.findbyCodeName')"
                      outlined
                      hide-details
                      dense
                      solo
                      @keyup.enter="queryCodeDataPool"
                    ></v-text-field>
                  </div>
                </v-col>
                <v-col lg="3" class="comm-header-col date-query-section pb-0 pr-0 pt-0 mt-0">
                  <div class="pl-0 pt-0 pb-0">
                    <v-text-field
                      v-model="codeDataPoolItems.data[0].SRC_CD"
                      class="data-table-filter-text-field search-button-data-analysis-table"
                      height="30"
                      :placeholder="$t('lbl.common.conditionSearch.findbySourceCode')"
                      outlined
                      hide-details
                      dense
                      solo
                      @keyup.enter="queryCodeDataPool"
                    ></v-text-field>
                  </div>
                </v-col>
                <v-col lg="3" class="comm-header-col date-query-section pb-0 pr-0 pt-0 mt-0">
                  <div class="pl-0 pt-0 pb-0">
                    <v-text-field
                      v-model="codeDataPoolItems.data[0].TRG_CD"
                      class="data-table-filter-text-field search-button-data-analysis-table repomatching"
                      height="30"
                      :placeholder="$t('lbl.common.conditionSearch.findbyTargetCode')"
                      outlined
                      hide-details
                      dense
                      solo
                      @keyup.enter="queryCodeDataPool"
                    ></v-text-field>
                  </div>
                </v-col>
              </v-row>
              <v-row class="ma-0 padding-code-table">
                <v-col class="pa-0">
                  <hot-table ref="hotTableComponent" :settings="hotSettings"> </hot-table>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card-text>
      </v-col>
    </v-row>
    <v-row class="custom-pagination-figma-v3-last pl-3 pr-3 mb-4">
      <v-col class="page-control-content page-control-bg transaction-pagi custom-popup-v3">
        <v-row>
          <v-col
            v-show="totalCount > 0"
            class="page-control-bg text-left custom-popup-v3 pa-0"
            cols="6"
          >
            <div class="custom-pagi-selectbox m-1" style="width:150px">
              <v-select
                v-model="itemsPerPage"
                :items="rowPerPage"
                :disabled="fromExcel"
                @change="queryCodeDataPool()"
                class="data-table-select-box custom-selectbox page-flat-file-selectbox pt-2"
                hide-details
                dense
                solo
              ></v-select>
            </div>
          </v-col>
          <v-col
            v-show="totalCount > 0"
            class="page-control-bg text-end custom-popup-v3 pa-0 pt-1"
            cols="6"
          >
            <div class="page-showing">
              <v-label>
                {{ itemsPerPage * (page - 1) + 1 }} ~
                {{ totalCount - itemsPerPage * page > 0 ? itemsPerPage * page : totalCount }} of
                {{ totalCount }}
              </v-label>
            </div>
            <button
              type="button"
              @click="
                page = 1;
                queryCodeDataPool(false);
              "
              :class="[
                'custom-btn-first-last-paging',
                page == 1 ? ' v-pagination__navigation--disabled' : '',
              ]"
            >
              <div class="ml-2 pr-2 d-inline">
                <span><i class="fa fa-sm fa-step-backward"></i></span>
              </div>
            </button>
            <button
              type="button"
              @click="changePageByTextbox(-1)"
              :class="[
                'mr-3 custom-btn-first-last-paging',
                page - 1 < 1 ? ' v-pagination__navigation--disabled' : '',
              ]"
            >
              <div class="ml-2 pr-2 d-inline">
                <span><i class="fa fa-lg fa-caret-left"></i></span>
              </div>
            </button>
            <v-text-field
              v-model="pageEnter"
              hide-details
              dense
              solo
              class="data-table-filter-text-field custom-pagi-selectbox page-selectbox"
              @keyup.enter="changePageByTextbox(0)"
            ></v-text-field
            ><label>/ {{ pageCount }}</label>
            <button
              type="button"
              @click="changePageByTextbox(1)"
              :class="[
                'ml-3 custom-btn-first-last-paging',
                page + 1 > pageCount ? ' v-pagination__navigation--disabled' : '',
              ]"
            >
              <div class="mr-2 pl-2 d-inline">
                <span><i class="fa fa-lg fa-caret-right"></i></span>
              </div>
            </button>
            <button
              type="button"
              @click="
                page = pageCount;
                queryCodeDataPool(false);
              "
              :class="[
                'custom-btn-first-last-paging',
                page == pageCount ? ' v-pagination__navigation--disabled' : '',
              ]"
            >
              <div class="mr-2 pl-2 d-inline">
                <span><i class="fa fa-sm fa-step-forward"></i></span>
              </div>
            </button>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-divider class="deviderColor mx-3 mb-2"></v-divider>
    <v-row>
      <v-col class="page-control-bg d-flex justify-between custom-popup-v3 pt-2 pb-0" cols="12">
        <div class="pl-3">
          <input
            type="file"
            ref="upload_file_input"
            @change="onFileChanged"
            style="display: none"
          />
          <v-btn
            v-if="$auth.manage"
            class="btn-top-table btn-excel"
            @click="$refs.upload_file_input.click()"
          >
            Upload Excel
          </v-btn>
        </div>
        <div class="btn-form-control text-right mx-4">
          <v-btn class="btn btn-delete btn-popup " @click="removeDialog">
            {{ $t('btn.common.close') }}
          </v-btn>
          <v-btn
            class="btn btn-add btn-popup"
            @click="onAdd"
            :disabled="!$auth.manage || fromExcel"
          >
            {{ $t('btn.common.add') }}
          </v-btn>
          <v-btn
            class="btn btn-popup-search btn-popup"
            color="primary"
            @click="onSave"
            :disabled="!$auth.manage"
          >
            {{ $t('btn.common.save') }}
          </v-btn>
        </div>
      </v-col>
    </v-row>
    <dialogWindow
      ref="successDialog"
      size="max"
      title="Success"
      color="success"
      @select-ok="queryCodeDataPool"
      :detail="$t('msg.codetable.codeDataPool.saveSuccess')"
    >
    </dialogWindow>
    <dialogWindow
      ref="WarningDialog"
      size="max"
      title="Warning"
      :detail="warnDetail"
      color="warning"
    >
    </dialogWindow>
    <dialogWindow
      ref="PassSave"
      title="Data changed"
      size="max"
      :detail="$t('msg.codetable.codeDataPool.confirm')"
      color="confirmation"
      :showCancel="true"
      @select-ok="passSave()"
    >
    </dialogWindow>
    <dialogWindow
      ref="validateUpload"
      size="max"
      detail="Only Excel file is allowed"
      color="validation"
    ></dialogWindow>
  </dialog-drag>
</template>

<script>
/* globals Store */

import IconSvg from '@/vue-caas/components/IconBase.vue';
import dialogWindow from '@/vue-dlb/components/NewDialog.vue';
import DialogDrag from '@/vue-dlb/components/vue-dialog-drag.vue';
import { HotTable } from '@handsontable/vue';
import Handsontable from 'handsontable';
import 'handsontable/dist/handsontable.full.css';
import { mapState } from 'vuex';
import XLSX from 'xlsx';

export default {
  name: 'code-data-pool-dialog',
  props: ['id', 'title', 'options', 'eventCb', 'selectFile', 'closeDialog', 'dragStart', 'dragEnd'],
  components: {
    DialogDrag,
    HotTable,
    dialogWindow,
    IconSvg,
  },
  computed: {
    ...mapState('codetable', {
      codeDataPool: 'allCodeDataPool',
    }),
  },
  data() {
    let self = this;
    return {
      page: 1,
      pageCount: 1,
      totalCount: 0,
      pageEnter: 1, // 2021.11.26 203728 SPKA-274 modify paging
      itemsPerPage: 1000, // amount of rows will get when scroll
      rowPerPage: [
        { value: 100, text: 'Show 100' },
        { value: 500, text: 'Show 500' },
        { value: 1000, text: 'Show 1000' },
      ],
      listPage: [{ value: 1, text: 'Page 1' }],
      changedGroupList: {
        header: ['GRP_CD'],
        data: [],
      },
      storeDataPool: [],
      clipboardCache: '',
      hotSettings: {
        copyPaste: true,
        colHeaders: ['Code Name', 'Source Code', 'Target Code'],
        columns: [
          { data: 'CODE_GRP_CD' },
          { data: 'CODE_ITM_SRC_CD' },
          { data: 'CODE_ITM_TRG_CD' },
        ],
        rowHeaders: function(index) {
          return self.itemsPerPage * (self.page - 1) + (index + 1);
        },
        beforePaste: function(data, coords) {
          if (data.length > 10000) {
            self.$refs.WarningDialog.dialog = true;
            self.warnDetail = self.$t('msg.codetable.codeDataPool.check10000');
            return false;
          }
          self.totalCount = data.length;
        },
        afterCopy: function(data, coords) {
          self.clipboardCache = data;
        },
        beforeRemoveRow: function(index, amount, physicalRows) {
          physicalRows.forEach((row) => {
            if (!self.fromExcel) self.removeRow(this.getSourceDataAtRow(row));
            this.getCellMeta(row, 0).valid = true;
            this.getCellMeta(row, 1).valid = true;
            this.getCellMeta(row, 2).valid = true;
          });
        },
        afterChange: function(changes, source) {
          if (self.fromExcel || !changes) return;
          changes.forEach(([row, prop, oldValue, newValue]) => {
            if (newValue != oldValue) self.updatedRow(this.getSourceDataAtRow(row));
          });
        },
        contextMenu: {
          items: {
            sp1: Handsontable.plugins.ContextMenu.SEPARATOR,
            insert_selected_rows_first: {
              name: 'Insert rows',
              callback: function() {
                const selected = this.getSelected();
                if (!selected) return;

                let newData = [];

                selected.forEach(([row, col, rowEnd, colEnd]) => {
                  if (col === -1) {
                    for (let r = row; r <= rowEnd; r++) {
                      const rowData = this.getSourceDataAtRow(r);
                      if (rowData) {
                        newData.push({
                          CODE_GRP_CD: rowData.CODE_GRP_CD,
                          CODE_ITM_SRC_CD: rowData.CODE_ITM_SRC_CD,
                          CODE_ITM_TRG_CD: rowData.CODE_ITM_TRG_CD,
                        });
                      }
                    }
                  } else {
                    for (let r = row; r <= rowEnd; r++) {
                      let rowData = {};
                      for (let c = col; c <= colEnd; c++) {
                        const prop = this.colToProp(c);
                        rowData[prop] = this.getDataAtCell(r, c);
                      }
                      newData.push(rowData);
                    }
                  }
                });
                this.alter('insert_row', 0, newData.length);

                newData.forEach((rowData, index) => {
                  Object.keys(rowData).forEach((key) => {
                    this.setDataAtRowProp(index, key, rowData[key]);
                  });
                });
              },
            },
            remove_row: {},
            sp2: Handsontable.plugins.ContextMenu.SEPARATOR,
            refresh: {
              name: 'Refresh',
              callback: function() {
                self.resetSave();
                self.queryCodeDataPool();
              },
            },
          },
        },
        width: 1022,
        height: 510,
        colWidths: [200, 120, 640],
        rowHeights: 25,
        startRows: 1,
        startCols: 3,
        columnSorting: true,
        autoWrapCol: false,
        invalidCellClassName: 'redCell',
        autoRowSize: true,
      },
      uploadCodeTable: {
        header: ['SYSSTATUS', 'CUST_ID', 'OWNR_CUST_ID', 'ITEM_SEQ', 'GRP_CD', 'SRC_CD', 'TRG_CD'],
        data: [],
      },
      codeDataPoolItems: {
        header: ['CUST_ID', 'OWNR_CUST_ID', 'GRP_CD', 'SRC_CD', 'TRG_CD', 'R_FROM', 'R_TO', 'SORT'],
        data: [
          {
            CUST_ID: '',
            OWNR_CUST_ID: '',
            GRP_CD: '',
            SRC_CD: '',
            TRG_CD: '',
            R_FROM: 1,
            R_TO: this.itemsPerPage,
            SORT: 'UPDATE',
          },
        ],
      },
      deleteList: [],
      updateList: [],
      totalRow: 0,
      fromExcel: false,
      warnDetail: '',
    };
  },

  created() {
    this.queryCodeDataPool();
  },
  watch: {
    pageCount(newVal, oldVal) {
      if (newVal != oldVal) {
        this.listPage = [];
        for (let i = 1; i <= newVal; i++) {
          this.listPage.push({ value: i, text: 'Page ' + i });
        }
      }
    },
    page() {
      this.pageEnter = this.page;
    },
  },
  methods: {
    readFile(file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        const bstr = e.target.result;
        const wb = XLSX.read(bstr, { type: 'binary' });

        const wsname = wb.SheetNames[0];
        const ws = wb.Sheets[wsname];

        const data = XLSX.utils.sheet_to_json(ws);

        this.loadCodeDataFromExcel(data);
      };
      reader.readAsBinaryString(file);
    },
    onFileChanged(e) {
      const files = e.target.files || [];
      let validExts = ['.xlsx', '.xls'];
      if (files && files[0]) {
        let fileExt = files[0].name.substring(files[0].name.lastIndexOf('.'));
        if (validExts.indexOf(fileExt) < 0) {
          this.$refs.validateUpload.dialog = true;
        } else {
          this.file = files[0];
          this.readFile(files[0]);
        }
      }
    },
    loadCodeDataFromExcel(dataUpload) {
      if (this.deleteList.length > 0 || this.updateList.length > 0) {
        this.$refs.PassSave.dialog = true;
        return;
      }
      this.fromExcel = true;

      const codeDataPool = Array.from({ length: 1000 }, () => ({
        ...{
          CODE_GRP_CD: '',
          CODE_ITM_SRC_CD: '',
          CODE_ITM_TRG_CD: '',
        },
      }));

      for (let i = 0; i < dataUpload.length; i++) {
        let element = dataUpload[i];
        codeDataPool[i] = {
          CODE_GRP_CD: element.CodeName?.trim() || '',
          CODE_ITM_SRC_CD: element.SourceCode?.trim() || '',
          CODE_ITM_TRG_CD: element.TargetCode?.trim() || '',
        };
      }
      let _this = this.$refs.hotTableComponent.hotInstance;
      this.totalCount = 0;
      this.pageCount = 1;
      this.page = 1;
      this.resetSave();
      _this.clear();
      this.storeDataPool = codeDataPool;
      _this.loadData(codeDataPool);
      _this.selectCell(0, 0);
    },
    changePageByTextbox(value) {
      let data = parseInt(this.pageEnter);
      if (isNaN(data)) {
        this.pageEnter = this.page;
        return;
      } else {
        this.page = data > this.pageCount ? this.pageCount : data < 1 ? 1 : data;
        this.pageEnter = this.page;
      }
      this.page += value;
      this.queryCodeDataPool(false);
    },
    onAdd() {
      let _this = this.$refs.hotTableComponent.hotInstance;
      _this.alter('insert_row', 0, 1);
      _this.selectCell(0, 0);
    },
    passSave() {
      this.resetSave();
      this.queryCodeDataPool(false);
    },
    queryCodeDataPool(resetPage = true) {
      if (resetPage) this.page = 1;
      if (this.deleteList.length > 0 || this.updateList.length > 0) {
        this.$refs.PassSave.dialog = true;
        return;
      }
      this.codeDataPoolItems.data[0].CUST_ID = this.$cookies.get('comp-id');
      this.codeDataPoolItems.data[0].OWNR_CUST_ID = this.$cookies.get('ownr-id');
      this.codeDataPoolItems.data[0].R_FROM = this.itemsPerPage * (this.page - 1) + 1;
      this.codeDataPoolItems.data[0].R_TO = this.itemsPerPage * this.page;

      Store.dispatch('codetable/codeDataPoolPaging', this.codeDataPoolItems).then((res) => {
        console.log('--------- Finished to process ----------');
        const resDt = res.codeDataPool.map((e) => {
          return {
            ...e,
            CODE_GRP_CD_OLD: e.CODE_GRP_CD,
          };
        });
        this.storeDataPool = resDt;
        this.totalCount = res.totalDataPool;

        this.pageCount = Math.floor(this.totalCount / this.itemsPerPage);
        if (this.itemsPerPage * this.pageCount !== this.totalCount) this.pageCount += 1;

        let _this = this.$refs.hotTableComponent.hotInstance;

        _this.clear();
        this.resetSave();
        _this.loadData(resDt);
        _this.selectCell(0, 0);
        if (resDt.length === 0) {
          _this.alter('insert_row', _this.countRows());
          _this.selectCell(_this.countRows() - 1, 'CODE_GRP_CD');
        }
      });
    },
    isEmpty(value) {
      return !value || value.trim() == '' ? true : false;
    },
    onSave() {
      this.uploadCodeTable.data = [];
      console.log('--------- Check data ----------');
      let _this = this.$refs.hotTableComponent.hotInstance;

      if (_this.countRows() > 10000) {
        self.$refs.WarningDialog.dialog = true;
        self.warnDetail = self.$t('msg.codetable.codeDataPool.check10000');
        return;
      }

      let data = _this.getData();
      let _rows = data.length;
      let row = -1,
        col = -1;

      for (let i = 0; i < _rows; i += 1) {
        // Reset valid
        _this.getCellMeta(i, 0).valid = true;
        _this.getCellMeta(i, 1).valid = true;
        // _this.getCellMeta(i, 2).valid = true;
        // If empty row => pass
        if (_this.isEmptyRow(i)) continue;
        // Check column data
        if (this.isEmpty(data[i][0])) {
          // CODE_GRP_CD
          _this.getCellMeta(i, 0).valid = false;
          if (col == -1) col = 0;
          if (row == -1) row = i;
        }
        if (this.isEmpty(data[i][1])) {
          // CODE_ITM_SRC_CD
          _this.getCellMeta(i, 1).valid = false;
          if (col == -1) col = 1;
          if (row == -1) row = i;
        }
        if (data[i][0].indexOf(' ') >= 0) {
          // CODE_GRP_CD
          _this.getCellMeta(i, 0).valid = false;
          if (col == -1) col = 0;
          if (row == -1) row = i;
          this.$refs.WarningDialog.dialog = true;
          this.warnDetail = this.$t('msg.codetable.codeDataPool.checkeWhiteSpace');
        }
      }

      if (row > -1) {
        _this.render();
        return _this.selectCell(row, col);
      }

      if (this.fromExcel) {
        data.map((e, i) => {
          if (!_this.isEmptyRow(i))
            this.uploadCodeTable.data.push({
              SYSSTATUS: 'I',
              CUST_ID: this.$cookies.get('comp-id'),
              OWNR_CUST_ID: this.$cookies.get('ownr-id'),
              ITEM_SEQ: '',
              GRP_CD: e[0],
              SRC_CD: e[1],
              TRG_CD: e[2],
            });
        });
      } else {
        data.map((e, i) => {
          let item = _this.getSourceDataAtRow(i);
          if (!_this.isEmptyRow(i) && !item.CODE_ITM_NO) {
            this.uploadCodeTable.data.push({
              SYSSTATUS: 'I',
              CUST_ID: this.$cookies.get('comp-id'),
              OWNR_CUST_ID: this.$cookies.get('ownr-id'),
              ITEM_SEQ: '',
              GRP_CD: item.CODE_GRP_CD,
              SRC_CD: item.CODE_ITM_SRC_CD,
              TRG_CD: item.CODE_ITM_TRG_CD,
            });
          }

          if (_this.isEmptyRow(i) && item.CODE_ITM_NO) this.removeRow(item);
        });
      }

      // Join delete list
      this.uploadCodeTable.data = this.uploadCodeTable.data.concat(this.deleteList);
      // Join update list
      this.uploadCodeTable.data = this.uploadCodeTable.data.concat(this.updateList);

      console.log('--------- Check duplicate ----------');
      let arrChk = data.map((e) => {
        return e[0] + e[1] + e[2];
      });
      let _index = 0;

      arrChk.findIndex((e, i) => {
        if (arrChk.indexOf(e) != i && !this.isEmpty(e)) {
          _this.getCellMeta(i, 0).valid = false;
          _this.getCellMeta(i, 1).valid = false;
          _index = i;
        }
      });

      if (_index > 0) {
        _this.render();
        this.$refs.WarningDialog.dialog = true;
        this.warnDetail = this.$t('msg.codetable.codeDataPool.dup');
        return _this.selectCell(_index, 0);
      }

      // Check save list
      if (this.uploadCodeTable.data.length == 0) {
        this.$refs.WarningDialog.dialog = true;
        this.warnDetail = this.$t('msg.codetable.codeDataPool.noData');
        return;
      }

      data = JSON.stringify(this.uploadCodeTable).replace(/\\n/g, '');

      const GroupCd = [];
      this.uploadCodeTable.data.forEach((element) => {
        GroupCd.push(element.GRP_CD);
      });

      const set = new Set(GroupCd);
      const distinctGroupCd = [...set];
      for (var i = 0; i < distinctGroupCd.length; i++) {
        this.changedGroupList.data[i] = {
          GRP_CD: distinctGroupCd[i],
        };
      }

      if (JSON.parse(data).length > 10000 && this.fromExcel) {
        self.$refs.WarningDialog.dialog = true;
        self.warnDetail = self.$t('msg.codetable.codeDataPool.check10000');
        return;
      } else if (JSON.parse(data).length > 1000) {
        this.$refs.WarningDialog.dialog = true;
        this.warnDetail = this.$t('msg.codetable.codeDataPool.check1000');
        return;
      }
      console.log('--------- savaData ----------', JSON.parse(data));
      Store.dispatch('codetable/saveCodeItems', JSON.parse(data)).then(() => {
        console.log('--------- Finished to process ----------');
        Store.dispatch('codetable/deployCodeList', this.changedGroupList).then(() => {
          console.log('--------- Finished to deploy ----------');
          this.resetSave();
          this.fromExcel = false;
          this.$emit('refreshData');
          this.$refs.successDialog.dialog = true;
        });
      });
    },
    resetSave() {
      this.deleteList = [];
      this.updateList = [];
      this.uploadCodeTable.data = [];
    },
    removeRow(item) {
      if (item.CODE_ITM_NO) {
        let record = {
          SYSSTATUS: 'D',
          ITEM_SEQ: item.CODE_ITM_NO,
          GRP_CD: item.CODE_GRP_CD_OLD,
        };
        // Remove from update list
        this.removeFromUpdateList(record);
        if (this.deleteList.findIndex((element) => element.ITEM_SEQ == record.ITEM_SEQ) == -1)
          this.deleteList.push(record);
      }
    },
    removeFromUpdateList(record) {
      // If delete record have in update list => remove it from update list
      let index = this.updateList.findIndex((element) => element.ITEM_SEQ == record.ITEM_SEQ);
      if (index > -1) this.updateList.splice(index, 1);
    },
    updatedRow(item) {
      if (item.CODE_ITM_NO) {
        let record = {
          SYSSTATUS: 'U',
          CUST_ID: this.$cookies.get('comp-id'),
          OWNR_CUST_ID: this.$cookies.get('ownr-id'),
          ITEM_SEQ: item.CODE_ITM_NO,
          GRP_CD: item.CODE_GRP_CD,
          SRC_CD: item.CODE_ITM_SRC_CD,
          TRG_CD: item.CODE_ITM_TRG_CD,
        };

        // Check if record in array => remove it
        let index = this.updateList.findIndex((element) => element.ITEM_SEQ == record.ITEM_SEQ);
        if (index > -1) this.updateList.splice(index, 1);
        // Push new record
        this.updateList.push(record);
      }
    },
    removeDialog(dialog) {
      dialog.id = this.id;
      this.closeDialog(dialog);
    },
    selectDialog(obj) {
      this.dragStart(obj);
    },
    dialogDragEnd(obj) {
      this.dragEnd(obj);
    },
  },
};
</script>
